"use client";

import { useEffect } from "react";
import Link from "next/link";
import { reportClientError } from "@/lib/error-log";
import "./globals.css";

// Faengt Fehler im Root-Layout selbst ab (z.B. AuthModalProvider, Footer) - anders als
// app/error.tsx MUSS diese Datei ihr eigenes <html>/<body> mitbringen, da sie das
// komplette Root-Layout ersetzt (Next.js-Konvention). Bewusst minimal/unabhaengig von
// SiteHeader & Co. gehalten, damit die Fehleransicht auch dann noch rendert, wenn genau
// eine dieser Komponenten die Ursache des Absturzes war.
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[app/global-error]", error.digest ?? "", error);
    reportClientError({ source: "app/global-error", message: error.message, stack: error.stack });
  }, [error]);

  return (
    <html lang="de">
      <body className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background px-4 text-center text-ink">
        <p className="font-serif text-xl">Erikonomie ist gerade nicht erreichbar</p>
        <p className="max-w-md text-sm text-muted-foreground">
          Da ist etwas grundlegend schiefgelaufen. Bitte lade die Seite neu.
        </p>
        <div className="flex items-center gap-4">
          <button
            onClick={reset}
            className="rounded-md border border-hairline px-4 py-2 text-sm font-medium hover:bg-muted"
          >
            Erneut versuchen
          </button>
          <Link href="/" className="text-sm font-medium text-secondary hover:text-ink">
            Zur Startseite
          </Link>
        </div>
      </body>
    </html>
  );
}
